import { Controller } from "@hotwired/stimulus"

// Mantém o chat no fim: ao abrir e a cada mensagem nova (append do turbo_stream).
export default class extends Controller {
  connect() {
    this.toBottom()
    this._observer = new MutationObserver(() => this.toBottom())
    this._observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this._observer?.disconnect()
    this._observer = null
  }

  toBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
